export default function MazeMuncherIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="12" fill="#0b0720" />
      <path d="M8 14h48M8 50h48M8 14v36M56 14v36" stroke="#3d8bff" strokeWidth="3" fill="none" strokeLinecap="round" />
      <circle cx="42" cy="34" r="2.2" fill="#d8ff9a" />
      <path d="M50 28 l1.4 4.6 4.6 1.4 -4.6 1.4 -1.4 4.6 -1.4 -4.6 -4.6 -1.4 4.6 -1.4z" fill="#fff3a8" />
      <ellipse cx="18" cy="45" rx="4" ry="2.2" fill="#3fae1c" />
      <ellipse cx="28" cy="45" rx="4" ry="2.2" fill="#3fae1c" />
      <ellipse cx="23" cy="34" rx="12" ry="11" fill="#8ff04a" stroke="#4fbf1f" strokeWidth="1.5" />
      <ellipse cx="19" cy="30" rx="2.8" ry="3.2" fill="#fff" />
      <ellipse cx="27" cy="30" rx="2.8" ry="3.2" fill="#fff" />
      <circle cx="20" cy="30" r="1.5" fill="#14102a" />
      <circle cx="28" cy="30" r="1.5" fill="#14102a" />
      <ellipse cx="23.5" cy="38" rx="6" ry="3.4" fill="#2a0f1a" />
      <rect x="20.5" y="34.6" width="2" height="1.8" fill="#fff" />
      <rect x="24.5" y="34.6" width="2" height="1.8" fill="#fff" />
      <path d="M23 23 q-1 -6 5 -6" stroke="#3fae1c" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    </svg>
  );
}
